import { AnalyticsEvent } from '@/types'

export const getAnalyticsEvent = async (
  inputEvent: AnalyticsEvent,
  site_language: string
): Promise<AnalyticsEvent> => {
  return {
    ...inputEvent,
    event_category: 'circular_hub',
    custom: {
      ...(inputEvent?.custom || {}),
      site_language: site_language,
    },
  }
}
